import { ResultBuilder } from "appworks/server/builders/result-builder";
import { SlingoRecord } from "slingo/model/records/slingo-record";
import { SlingoReelSpinResult } from "slingo/model/results/slingo-reel-spin-result";
import { SlingoResponse } from "slingo/integration/slingo-schema";

export class SlingoReelSpinResultBuilder implements ResultBuilder {
    public filter(data: SlingoResponse, record?: SlingoRecord): boolean {
        return data.spinResult && Boolean(data.spinResult.reelSequence);
    }

    public build(record: SlingoRecord, data: SlingoResponse): SlingoReelSpinResult[] {
        const result = new SlingoReelSpinResult();

        result.spinType = data.spinResult.spinType;
        result.patterns = data.spinResult.patternWin.numberOfPatterns;
        result.symbols = data.spinResult.reelSequence.symbols.map(symbol => this.mapSymbol(symbol));
        result.matches = [];
        for (const match of data.spinResult.matchedNumbers) {
            result.matches.push({
                matchedValue: match,
                reelIndex: result.symbols.indexOf(match.toString())
            })
        }

        return [result];
    }

    protected mapSymbol(serverSymbolId: string): string {
        return serverSymbolId;
    }
}
